module.exports = __webpack_public_path__ + "static/media/collect-stars.bf556ecc.png";